const companyThemeServiceConfig = {
  getById: '/CompanyTheme/',
};
export default companyThemeServiceConfig;
